export function parseDateToUnixSeconds(value: string): number | undefined {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const ddmmyyyy = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const ddmmyy = /^(\d{2})\/(\d{2})\/(\d{2})$/;
  const fullYearMatch = trimmed.match(ddmmyyyy);
  const shortYearMatch = trimmed.match(ddmmyy);
  const matched = fullYearMatch || shortYearMatch;

  if (matched) {
    const day = Number(matched[1]);
    const month = Number(matched[2]);
    const year =
      matched[3].length === 2 ? 2000 + Number(matched[3]) : Number(matched[3]);

    if (day >= 1 && day <= 31 && month >= 1 && month <= 12) {
      return Math.floor(new Date(year, month - 1, day).getTime() / 1000);
    }
  }

  const asNumber = Number(trimmed);
  if (Number.isFinite(asNumber)) {
    return asNumber > 1_000_000_000_000
      ? Math.floor(asNumber / 1000)
      : Math.floor(asNumber);
  }

  const parsed = Date.parse(trimmed);
  if (Number.isNaN(parsed)) return undefined;

  return Math.floor(parsed / 1000);
}

export function parseAmountToNumber(value: string): number | undefined {
  const normalized = value.replace(/[^\d]/g, '');
  if (!normalized) return undefined;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function formatDisplayAmount(value: string): string {
  const numeric = value.replace(/[^\d]/g, '');
  if (!numeric) return '';

  return numeric.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
